import { Box, Card, CardContent, CardHeader, FormLabel, Grid } from '@mui/material';
import { Skeleton } from '@mui/material';
import { theme } from 'theme';
import MemberCodeIcon from 'assets/icons/Membercode.svg?react';
import { LanguageEnum } from 'pco-product-service-internal-consumer';

const styles = {
  circle: {
    marginRight: theme.spacing(4),
  },
};

export const CreateAccessCodeFormSkeleton = () => (
  <Card id={'create-access-code-form-skeleton'} style={{ maxWidth: '90%' }} square>
    <Grid container style={{ paddingLeft: theme.spacing(2) }}>
      <MemberCodeIcon style={{ marginTop: theme.spacing(2) }} />
      <CardHeader
        title={'CREATE ACTIVATION CODE'}
        titleTypographyProps={{ variant: 'subtitle1' }}
        style={{
          paddingBottom: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        }}
      />
    </Grid>
    <CardContent style={{ paddingTop: 1 }}>
      <Grid container spacing={2} style={{ paddingTop: theme.spacing(1) }}>
        <Grid item xs={6}>
          <FormLabel id={'skeleton-memberzone-first-name-label'}>First name</FormLabel>
          <Skeleton animation="wave" variant="rectangular" width={'100%'} height={30} />
        </Grid>
        <Grid item xs={6}>
          <FormLabel id={'skeleton-memberzone-last-name-label'}>Last name</FormLabel>
          <Skeleton animation="wave" variant="rectangular" width={'100%'} height={30} />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: theme.spacing(1) }}>
        <Grid item xs={6}>
          <FormLabel id={'skeleton-memberzone-main-domicile-label'}>Main domicile (country)</FormLabel>

          <Skeleton animation="wave" variant="rectangular" width={'100%'} height={30} />
        </Grid>
        <Grid item xs={6}>
          <FormLabel id={'skeleton-memberzone-email-language-label'}>Email language</FormLabel>
          <Box
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-start',
            }}
          >
            {Object.values(LanguageEnum).map((_: LanguageEnum, i: number) => (
              <Skeleton
                key={`circle-skeleton-${i}`}
                data-testid={`circle-skeleton-${i}`}
                sx={styles.circle}
                animation="wave"
                variant="circular"
                width={30}
                height={30}
              />
            ))}
          </Box>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);
